export const PLATFORM_APP_ID = '#root';
